import { gql } from 'graphql-request'

export const EXPORT_COIN_REMAIN = gql`
  query ExportCoinRemain($orderBy: CoinRemainOrderBy) {
    exportCoinRemain(orderBy: $orderBy)
  }
`
